import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createMetaDataMappingInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_BEGIN,
    });
    const { projectId, version, data, selectedCollection } = args;
    const { uuid: collectionUuid } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/meta-data-mapping/${collectionUuid}/collection`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_SUCCESS,
            data: res.data.metaDataTableMapping,
          });
          Mixpanel.track('Created Meta Data Mapping in Collection');
          toast.success('Created Successfully !');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create meta data mapping in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateMetaDataMappingInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createMetaDataMappingInCollectionPending: true,
        createMetaDataMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_SUCCESS:
      return {
        ...state,
        createMetaDataMappingInCollectionPending: false,
        createMetaDataMappingInCollectionError: null,
        metaDataTableMappings: action.data,
      };

    case COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createMetaDataMappingInCollectionPending: false,
        createMetaDataMappingInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createMetaDataMappingInCollectionError: null,
      };

    default:
      return state;
  }
}
